import { CakeApiBase } from '../CakeApiBase';
import { AnySwapGetQuota } from '../../schema/dex/any-swap-quota';

export class AnySwapApi extends CakeApiBase {
  async getSwapGetQuote(from: string, to: string, amount: number | string) {
    return this.requestManager.get<AnySwapGetQuota>(`/any-swap/getQuote?sourceCoinId=${from}&targetCoinId=${to}&amount=${amount}`);
  }
}
